import { render } from "./PoliticaPrivacidad.vue?vue&type=template&id=1475e67a&scoped=true"
import script from "./PoliticaPrivacidad.vue?vue&type=script&lang=js"
export * from "./PoliticaPrivacidad.vue?vue&type=script&lang=js"

import "./PoliticaPrivacidad.vue?vue&type=style&index=0&id=1475e67a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1475e67a"]])

export default __exports__